import { MutationTree } from "vuex";
import { MyCourseState } from "./types";

export const mutations: MutationTree<MyCourseState> = {};
